const root = document.documentElement;
const prefersReduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const $ = (selector, scope = document) => scope.querySelector(selector);
const queryAll = (selector, scope = document) => [...scope.querySelectorAll(selector)];
const bootstrap = window.__NUBIA_BOOTSTRAP__ || {};
const exportMode = Boolean(window.__NUBIA_EXPORT__);
const offlineMode = exportMode || window.location.protocol === "file:";
const pathPrefix = typeof window.__NUBIA_PATH_PREFIX__ === "string" ? window.__NUBIA_PATH_PREFIX__ : "";
const siteOrigin = typeof window.__NUBIA_SITE_ORIGIN__ === "string"
  ? window.__NUBIA_SITE_ORIGIN__.replace(/\/+$/, "")
  : (/^https?:$/i.test(window.location.protocol) ? window.location.origin : "");

const state = {
  products: [],
  cart: [],
  lang: "fr",
  anime: null,
  pointer: { x: innerWidth / 2, y: innerHeight / 2 },
  particles: []
};

const TRANSLATION_PAIRS = [
  ["Recherche", "Search"],
  ["Panier", "Cart"],
  ["Changer la langue", "Change language"],
  ["Finder", "Finder"],
  ["Quel rituel tu veux?", "What ritual do you want?"],
  ["Calcul pro", "Pro calculator"],
  ["Commande professionnelle locale.", "Local professional order."],
  ["Kg personnalisé", "Custom kg"],
  ["Format", "Format"],
  ["Sacs", "Bags"],
  ["Cost", "Cost"],
  ["Store", "Store"],
  ["Size", "Size"],
  ["CAD", "CAD"],
  ["best", "best"],
  ["Du Cameroun à ton matin.", "From Cameroon to your morning."],
  ["Café camerounais premium", "Premium Cameroonian coffee"],
  ["Cafés d'origine claire, torréfiés à Montréal pour des rituels qui te ressemblent.", "Single-origin coffees roasted in Montreal for rituals that feel like yours."],
  ["Choisir mon café", "Choose my coffee"],
  ["Chocolat au lait", "Milk chocolate"],
  ["Chocolat noir", "Dark chocolate"],
  ["Fruits rouges", "Red fruits"],
  ["Miel", "Honey"],
  ["Noix grillées", "Roasted nuts"],
  ["Cassis", "Black currant"],
  ["Épices", "Spice"],
  ["Boissons au lait", "Milk drinks"],
  ["Éclats de cacao", "Cacao nibs"],
  ["Caramel brûlé", "Burnt caramel"],
  ["Épices à pâtisserie", "Baking spice"],
  ["Mélasse", "Molasses"],
  ["Bois fumé", "Smoked wood"],
  ["Amandes grillées", "Roasted almonds"],
  ["Cassonade", "Brown sugar"],
  ["Céréales grillées", "Toasted grains"],
  ["Trouve ton profil Nubia", "Find your Nubia profile"],
  ["Rechercher", "Search"],
  ["Aucun résultat.", "No results."],
  ["Voir les cafés", "See coffees"],
  ["Grain entier", "Whole bean"],
  ["Traçabilité", "Traceability"],
  ["Emballage", "Packaging"],
  ["Commence par ton rituel", "Start with your ritual"],
  ["On t'aide à trouver ton café idéal.", "We help you find your ideal coffee."],
  ["Matin", "Morning"],
  ["Énergie douce", "Soft energy"],
  ["Concentration", "Focus"],
  ["Clarté & focus", "Clarity & focus"],
  ["Après-midi", "Afternoon"],
  ["Équilibre", "Balance"],
  ["Soir", "Evening"],
  ["Doux & réconfort", "Soft & comforting"],
  ["Riche & corse", "Rich & bold"],
  ["Répondre en 30 sec", "Answer in 30 sec"],
  ["Compare et choisis en confiance", "Compare and choose confidently"],
  ["Quatre profils. Quatre expériences.", "Four profiles. Four experiences."],
  ["Voir tous les cafés", "See all coffees"],
  ["Notre origine", "Our origin"],
  ["Un terroir. Des gens. Un standard.", "One terroir. Real people. One standard."],
  ["Nos cafés viennent des hauts plateaux du Cameroun. Des fermes partenaires, des pratiques durables, et une traçabilité totale.", "Our coffees come from Cameroon's highlands. Partner farms, durable practices, and full traceability."],
  ["Ouest Cameroun", "West Cameroon"],
  ["Altitude", "Altitude"],
  ["Espèce", "Species"],
  ["Récolte", "Harvest"],
  ["Séchage", "Drying"],
  ["Score qualité", "Quality score"],
  ["Voir la carte", "See the map"],
  ["Torréfié à Montréal", "Roasted in Montreal"],
  ["Petites torréfactions, fraîcheur garantie.", "Small-batch roasting, freshness guaranteed."],
  ["Livraison rapide", "Fast delivery"],
  ["Gratuite dès 100 $ à Montréal.", "Free over $100 in Montreal."],
  ["Satisfait ou ajusté", "Satisfied or adjusted"],
  ["On t'aide à trouver le bon profil.", "We help you find the right profile."],
  ["Paiement sécurisé", "Secure payment"],
  ["Carte, Apple Pay, Google Pay.", "Card, Apple Pay, Google Pay."],
  ["Club Nubia", "Nubia Club"],
  ["Rejoins le club, partage le goût.", "Join the club, share the taste."],
  ["Cafés exclusifs, offres membres et 10 $ de crédit quand un ami passe sa première commande.", "Exclusive coffees, member offers, and $10 credit when a friend places their first order."],
  ["Rejoindre le club", "Join the club"],
  ["10 $ pour toi", "$10 for you"],
  ["Crédit après chaque ami référé.", "Credit after each referred friend."],
  ["Offres exclusives", "Exclusive offers"],
  ["Réservées aux membres.", "Members only."],
  ["Accès prioritaire", "Priority access"],
  ["Nouveaux lots & éditions limitées.", "New lots & limited editions."],
  ["Boutique Nubia", "Nubia shop"],
  ["Choisis selon ta tasse.", "Choose by your cup."],
  ["Chaque café est présenté par usage, intensité, notes et méthode. Moins d'hésitation, meilleur premier achat.", "Every coffee is presented by use, intensity, notes and method. Less hesitation, a better first purchase."],
  ["Tous", "All"],
  ["Magasiner vite", "Shop fast"],
  ["Commence par ton rituel, puis compare seulement les profils qui ont du sens.", "Start with your ritual, then compare only the profiles that make sense."],
  ["Ouvrir le finder", "Open finder"],
  ["Livraison gratuite des 100 $", "Free shipping over $100"],
  ["Guide par usage", "Guide by use"],
  ["Notes de", "Notes"],
  ["Idéal pour", "Best for"],
  ["Ajouter au panier", "Add to cart"],
  ["Ajouter", "Add"],
  ["Voir le profil", "View profile"],
  ["Taxes et livraison au checkout", "Taxes and shipping at checkout"],
  ["Calculer format pro", "Calculate pro format"],
  ["Profil", "Profile"],
  ["Ce que tu vas remarquer.", "What you will notice."],
  ["Lecture rapide", "Quick read"],
  ["Structure tasse", "Cup structure"],
  ["Methode", "Method"],
  ["Méthode", "Method"],
  ["Fais simple.", "Keep it simple."],
  ["Comparer", "Compare"],
  ["Autres profils Nubia", "Other Nubia profiles"],
  ["Guide des rituels", "Ritual guide"],
  ["Choisis ton café sans devenir barista.", "Choose your coffee without becoming a barista."],
  ["Le bon sac se décide avec une question simple: comment tu le bois chez toi. Le reste sert seulement à confirmer le choix.", "The right bag starts with one simple question: how you drink it at home. The rest only confirms the choice."],
  ["Je bois avec du lait", "I drink it with milk"],
  ["Je veux un espresso dense", "I want a dense espresso"],
  ["Je veux un sac safe", "I want a safe pick"],
  ["Je veux plus doux", "I want something softer"],
  ["Corps rond, faible acidité, texture smooth.", "Round body, low acidity, smooth texture."],
  ["Cacao, crema, finale plus longue.", "Cacao, crema, longer finish."],
  ["Équilibre, caramel, café quotidien.", "Balanced, caramel, everyday coffee."],
  ["Sucre, finesse, intensité plus calme.", "Sugar, finesse, calmer intensity."],
  ["Usage", "Use"],
  ["Ce que ca veut dire", "What it means"],
  ["Ce que ça veut dire", "What it means"],
  ["Produit logique", "Logical product"],
  ["Le café doit rester rond avec le lait.", "The coffee should stay round with milk."],
  ["Tu veux du corps, de la crema, une finale cacao.", "You want body, crema and a cacao finish."],
  ["Tu veux lire plus clairement l'équilibre et la douceur.", "You want to read balance and sweetness more clearly."],
  ["Tu veux une tasse plus lourde, plus chaude, plus assumée.", "You want a heavier, warmer, more assertive cup."],
  ["Commence avec ta methode.", "Start with your method."],
  ["Commence avec ta méthode.", "Start with your method."],
  ["Machine espresso, moka pot, filtre, latte: c'est ça qui décide le profil en premier.", "Espresso machine, moka pot, filter, latte: that decides the profile first."],
  ["Lis le body avant les notes.", "Read body before notes."],
  ["Les notes sont utiles, mais le body détermine si le café va sembler faible, rond ou dense.", "Notes help, but body decides if the coffee feels weak, round or dense."],
  ["Garde un favori.", "Keep a favorite."],
  ["Quand tu sais ce qui marche dans ta tasse, reviens au même profil sans refaire toute la recherche.", "When you know what works in your cup, come back to the same profile without restarting the search."],
  ["Contact", "Contact"],
  ["La bonne demande, au bon endroit.", "The right request, in the right place."],
  ["Commande en ligne, distribution locale, collaboration ou café pour bureau: envoie le contexte et on te répond avec la prochaine étape claire.", "Online order, local distribution, collaboration or office coffee: send the context and we will answer with a clear next step."],
  ["Montréal", "Montreal"],
  ["Boutique", "Shop"],
  ["Distribution", "Distribution"],
  ["Nom", "Name"],
  ["Sujet", "Subject"],
  ["Commande", "Order"],
  ["Collaboration", "Collaboration"],
  ["Commande boutique", "Shop order"],
  ["Suivi, livraison, retour panier ou question sur un profil avant d'acheter.", "Tracking, delivery, cart follow-up or a profile question before buying."],
  ["Distribution locale", "Local distribution"],
  ["Restaurant, bureau, marché, épicerie fine ou collaboration B2B à Montréal.", "Restaurant, office, market, fine grocery or B2B collaboration in Montreal."],
  ["Partenariat brand", "Brand partnership"],
  ["Contenu, événement, dégustation ou activation autour de l'origine camerounaise.", "Content, event, tasting or activation around Cameroonian origin."],
  ["Lire le guide", "Read the guide"],
  ["Panier", "Cart"],
  ["Ta sélection Nubia.", "Your Nubia selection."],
  ["Vérifie tes sacs, ajuste les quantités, puis passe au checkout.", "Review your bags, adjust quantities, then continue to checkout."],
  ["Finaliser le rituel.", "Finalize the ritual."],
  ["Prépare ta commande, choisis la livraison, puis garde ton code de partage après confirmation.", "Prepare your order, choose delivery, then keep your sharing code after confirmation."],
  ["Ville", "City"],
  ["Montréal / livraison locale", "Montreal / local delivery"],
  ["Pickup / à confirmer", "Pickup / to confirm"],
  ["Code promo ou referral", "Promo or referral code"],
  ["Sous-total", "Subtotal"],
  ["Livraison", "Shipping"],
  ["Taxes est.", "Est. taxes"],
  ["Total", "Total"],
  ["Ton panier est vide.", "Your cart is empty."],
  ["Aucun profil trouve.", "No profile found."],
  ["Aucun profil trouvé.", "No profile found."],
  ["Essaie espresso ou latte", "Try espresso or latte"],
  ["Gratuit", "Free"],
  ["Recu. Profil suggere:", "Received. Suggested profile:"],
  ["Reçu. Profil suggéré:", "Received. Suggested profile:"],
  ["Le profil est pret, mais la capture locale n'a pas repondu.", "The profile is ready, but the local capture did not respond."],
  ["Le profil est prêt, mais la capture locale n'a pas répondu.", "The profile is ready, but the local capture did not respond."],
  ["Ajoute un cafe avant de confirmer.", "Add a coffee before confirming."],
  ["Ajoute un café avant de confirmer.", "Add a coffee before confirming."],
  ["Commande preparee.", "Order prepared."],
  ["Commande préparée.", "Order prepared."],
  ["Lien copie", "Link copied"],
  ["Lien copié", "Link copied"],
  ["Bags", "Bags"],
  ["Boutique", "Shop"],
  ["Tous les cafés", "All coffees"],
  ["Découvrir", "Discover"],
  ["Notre origine", "Our origin"],
  ["Nous contacter", "Contact us"],
  ["Profil signature", "Signature profile"],
  ["Profil origine", "Origin profile"],
  ["Profil puissant", "Power profile"],
  ["Profil intense", "Intense profile"],
  ["Profil arabica", "Arabica profile"],
  ["Profil equilibre", "Balanced profile"],
  ["Profond / crémeux", "Deep / creamy"],
  ["Rond / smooth", "Round / smooth"],
  ["Dense / cacao", "Dense / cacao"],
  ["Intense / épicé", "Intense / spiced"],
  ["Doux / raffiné", "Soft / refined"],
  ["Équilibre / quotidien", "Balanced / everyday"],
  ["Pour ceux qui veulent un café profond, crémeux, avec une vraie présence en lait.", "For people who want a deep, creamy coffee with real presence in milk."],
  ["Le profil le plus smooth pour les rituels quotidiens: rond, accessible, mais premium.", "The smoothest profile for daily rituals: round, accessible, but premium."],
  ["Un dark roast puissant, dense, construit pour l'espresso et les methodes qui demandent du corps.", "A powerful, dense dark roast built for espresso and methods that need body."],
  ["Le module le plus intense: cacao, dark choco, spices, crema dense et finish assumée.", "The most intense profile: cacao, dark chocolate, spices, dense crema and a confident finish."],
  ["Un profil plus doux et lumineux: milk chocolate, fruits rouges, miel, equilibre et finesse.", "A softer, brighter profile: milk chocolate, red fruits, honey, balance and finesse."],
  ["Le point d'entrée signature: full body, structure équilibrée, caramel, choco et amandes grillées.", "The signature entry point: full body, balanced structure, caramel, chocolate and roasted almonds."],
  ["Oku est le profil signature pour un café intense mais enveloppant. Il garde une texture riche, une crema rassurante et une finale qui fonctionne autant en espresso qu'en lait.", "Oku is the signature profile for an intense but enveloping coffee. It keeps a rich texture, steady crema and a finish that works in espresso and milk."],
  ["Continent met l'origine au centre. C'est le profil qui donne à Nubia son ancrage: une tasse ronde, douce, basse en acidité, facile à aimer mais clairement premium.", "Continent puts the origin at the center. It gives Nubia its anchor: a round, soft, low-acidity cup that is easy to love but clearly premium."],
  ["Volcan est construit comme un moteur: dense, stable, rassurant. Il donne au client l'impression d'un cafe qui ne flanche pas, avec une presence cacao tres nette.", "Volcan is built like an engine: dense, stable, reassuring. It gives the feeling of a coffee that does not collapse, with a clear cacao presence."],
  ["Moungo est le profil qui vend le frisson. Il doit sentir la chaleur, la pression, la densité. C'est le café pour ceux qui veulent que leur espresso ait du poids.", "Moungo is the profile that sells the thrill. It should feel hot, pressurized and dense. It is for people who want their espresso to carry weight."],
  ["Aurore-237 apporte la lumière dans l'univers Nubia. Il garde le côté premium, mais ouvre une expérience plus douce, plus accessible, plus élégante.", "Aurore-237 brings light into Nubia's world. It keeps the premium feeling while opening a softer, more accessible, more elegant experience."],
  ["SAWA est le profil qui porte la collection. Il est assez riche pour vendre la qualité, assez balancé pour devenir le café quotidien.", "SAWA carries the collection. It is rich enough to sell quality and balanced enough to become the daily coffee."],
  ["Prev", "Prev"],
  ["Next", "Next"],
  ["Quantite", "Quantity"],
  ["Fermer", "Close"],
  ["Voir le panier", "Review cart"],
  ["Passer au checkout", "Go to checkout"],
  ["espresso, latte, cacao, smooth...", "espresso, latte, cacao, smooth..."],
  ["Point de depart", "Starting point"],
  ["Ta tasse décide.", "Your cup decides."],
  ["Va direct à la situation qui te ressemble.", "Go straight to the situation that sounds like you."],
  ["Chaque choix mène à un produit, pas à un paragraphe de théorie.", "Each choice leads to a product, not a paragraph of theory."],
  ["Comment lire un sac Nubia en 20 secondes.", "How to read a Nubia bag in 20 seconds."],
  ["Ignore les mots qui ne changent rien dans ta tasse. Regarde l'usage, le body, l'acidité et la méthode recommandée.", "Ignore the words that do not change your cup. Look at use, body, acidity and recommended method."],
  ["Le Cameroun n'est pas un décor. C'est le point de départ.", "Cameroon is not decoration. It is the starting point."],
  ["L'origine donne la matière première. Nubia te l'explique vite, t'oriente mieux, et rend le choix évident.", "Origin gives the raw material. Nubia explains it fast, guides you better and makes the choice obvious."],
  ["Voir ma reponse", "See my answer"],
  ["Magasiner", "Shop"],
  ["Choisir maintenant", "Choose now"],
  ["Latte", "Latte"],
  ["Filtre", "Filter"],
  ["Intense", "Intense"],
  ["Commande boutique", "Shop order"],
  ["Restaurant, bureau, marché, épicerie fine ou collaboration B2B à Montréal.", "Restaurant, office, market, fine grocery or B2B collaboration in Montreal."],
  ["Profil origine", "Origin profile"],
  ["Contenu, événement, dégustation ou activation autour de l'origine camerounaise.", "Content, event, tasting or activation around Cameroonian origin."],
  ["Profil", "Profile"],
  ["Methode", "Method"],
  ["Résumé", "Summary"],
  ["Continuer au checkout", "Continue to checkout"],
  ["Continuer à magasiner", "Keep shopping"],
  ["Coordonnées", "Contact details"],
  ["Confirmer la commande", "Confirm order"],
  ["La confirmation apparaîtra ici.", "Confirmation will appear here."],
  ["Résumé commande", "Order summary"],
  ["Ton panier est vide pour l'instant.", "Your cart is empty for now."],
  ["Après achat", "After purchase"],
  ["Copier le lien", "Copy link"],
  ["Partage ton code avec quelqu'un qui devrait decouvrir Nubia.", "Share your code with someone who should discover Nubia."],
  ["Ton nom", "Your name"],
  ["Votre nom", "Your name"],
  ["toi@email.com", "you@email.com"],
  ["Décrivez votre demande", "Describe your request"],
  ["Nom complet", "Full name"],
  ["Envoyer", "Send"],
  ["Ton message apparaîtra ici.", "Your message will appear here."],
  ["Chocolat au lait", "Milk chocolate"],
  ["Chocolat noir", "Dark chocolate"],
  ["Fruits rouges", "Red fruits"],
  ["Miel", "Honey"],
  ["Noix grillées", "Roasted nuts"],
  ["Cassis", "Black currant"],
  ["Épices", "Spice"],
  ["Boissons au lait", "Milk drinks"],
  ["Éclats de cacao", "Cacao nibs"],
  ["Caramel brûlé", "Burnt caramel"],
  ["Épices à pâtisserie", "Baking spice"],
  ["Mélasse", "Molasses"],
  ["Bois fumé", "Smoked wood"],
  ["Amandes grillées", "Roasted almonds"],
  ["Cassonade", "Brown sugar"],
  ["Céréales grillées", "Toasted grains"],
  ["Trouve ton profil Nubia", "Find your Nubia profile"],
  ["Rechercher", "Search"],
  ["Aucun résultat.", "No results."],
  ["Voir les cafés", "See coffees"]
];

const translationLookup = new Map();
TRANSLATION_PAIRS.forEach(([fr, en]) => {
  translationLookup.set(fr.trim(), { fr, en });
  translationLookup.set(en.trim(), { fr, en });
});

function translateText(value, lang = state.lang) {
  const original = String(value || "");
  const trimmed = original.trim().replace(/\s+/g, " ");
  const pair = translationLookup.get(trimmed);
  if (!pair) return original;
  const next = lang === "en" ? pair.en : pair.fr;
  return original.replace(trimmed, next);
}

const TRANSLATABLE_ATTRS = ["placeholder", "aria-label", "title"];

function applyAutoTranslations(lang = state.lang) {
  if (!document.body) return;

  queryAll("[data-split]").forEach((node) => {
    const next = translateText(node.textContent, lang);
    if (next !== node.textContent) {
      node.textContent = next;
      delete node.dataset.splitReady;
    }
  });

  const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, {
    acceptNode(node) {
      if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
      const parent = node.parentElement;
      if (!parent || parent.closest("script, style, noscript, svg, canvas, .brand-word, [data-no-auto-i18n]")) {
        return NodeFilter.FILTER_REJECT;
      }
      return NodeFilter.FILTER_ACCEPT;
    }
  });

  const textNodes = [];
  while (walker.nextNode()) textNodes.push(walker.currentNode);
  textNodes.forEach((node) => {
    const next = translateText(node.nodeValue, lang);
    if (next !== node.nodeValue) node.nodeValue = next;
  });

  queryAll("[placeholder], [aria-label], [title]").forEach((node) => {
    TRANSLATABLE_ATTRS.forEach((attr) => {
      if (!node.hasAttribute(attr)) return;
      const next = translateText(node.getAttribute(attr), lang);
      if (next !== node.getAttribute(attr)) node.setAttribute(attr, next);
    });
  });
}

function money(value) {
  return "$" + Number(value || 0).toFixed(2) + " CAD";
}

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

function pathFor(target) {
  if (!target) return target;
  if (!offlineMode || !String(target).startsWith("/")) return target;
  if (target === "/") return `${pathPrefix}index.html`;
  if (/\.[a-z0-9]+$/i.test(target)) return `${pathPrefix}${target.replace(/^\//, "")}`;
  return `${pathPrefix}${target.replace(/^\//, "").replace(/\/?$/, "/index.html")}`;
}

async function loadProducts() {
  if (state.products.length) return state.products;
  // Shopify supplies the catalogue in Liquid; the prototype API is not available here.
  state.products = (Array.isArray(bootstrap.products) ? bootstrap.products : [])
    .filter((product) => product && typeof product.name === "string" && typeof product.slug === "string")
    .map((product) => ({
      ...product,
      notes: Array.isArray(product.notes) ? product.notes : [],
      methods: Array.isArray(product.methods) ? product.methods : []
    }));
  return state.products;
}

function escapeProductHtml(value) {
  return String(value ?? "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[character]));
}

function initCompareProfiles() {
  const productByName = new Map(state.products.map((product) => [product.name.toLowerCase(), product]));
  queryAll(".compare-table em").forEach((node) => {
    const names = node.textContent.split("/").map((name) => name.trim()).filter(Boolean);
    const profiles = names.map((name) => productByName.get(name.toLowerCase())).filter(Boolean);
    if (!profiles.length) return;

    const wrapper = document.createElement("div");
    wrapper.className = "compare-profiles";
    profiles.forEach((product) => {
      const link = document.createElement("a");
      link.className = "compare-profile-pill";
      link.href = pathFor(`/products/${product.slug}`);
      link.style.setProperty("--accent", product.accent || "#c08552");
      link.style.setProperty("--soft", product.soft || "rgba(255, 248, 235, .5)");
      link.innerHTML = `<img src="${escapeProductHtml(product.tile || product.image || "")}" alt="" loading="lazy" decoding="async" /><span>${escapeProductHtml(product.name)}</span>`;
      wrapper.appendChild(link);
    });
    node.replaceWith(wrapper);
  });
}

function renderGuideCoffeeLinks() {
  const target = $(".da-guide .da-steps article:nth-child(3) small");
  if (!target || !state.products.length) return;

  const bySlug = new Map(state.products.map((product) => [product.slug, product]));
  const linkFor = (slug) => {
    const product = bySlug.get(slug);
    if (!product) return "";
    return `<a class="da-coffee-link" href="${escapeProductHtml(pathFor(`/products/${product.slug}`))}" style="--accent:${escapeProductHtml(product.accent || "#c08552")}">${escapeProductHtml(product.name)}</a>`;
  };

  target.classList.add("da-step-products");
  if (state.lang === "en") {
    target.innerHTML = `${linkFor("atlas")}/${linkFor("cameroun")} to start. ${linkFor("onyx")}/${linkFor("vulcan")} for more weight.`;
  } else {
    target.innerHTML = `${linkFor("atlas")}/${linkFor("cameroun")} pour commencer. ${linkFor("onyx")}/${linkFor("vulcan")} pour plus de poids.`;
  }
}

function track() {}

function applyLanguage(lang, resplit = false) {
  state.lang = lang === "en" ? "en" : "fr";
  root.lang = state.lang;
  document.body.dataset.lang = state.lang;
  try { localStorage.setItem("nubia-lang-v1", state.lang); } catch {}
  queryAll("a[href]").forEach((link) => {
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || !/^\/checkout\/?$/.test(url.pathname)) return;
    url.searchParams.set("locale", state.lang);
    link.href = url.href;
  });

  queryAll("[data-i18n]").forEach((node) => {
    const value = state.lang === "en" ? node.dataset.en : node.dataset.fr;
    if (value) node.textContent = value;
  });
  queryAll("[data-lang-current]").forEach((node) => { node.textContent = state.lang.toUpperCase(); });
  queryAll("[data-lang-next]").forEach((node) => { node.textContent = state.lang === "en" ? "FR" : "EN"; });
  applyAutoTranslations(state.lang);
  renderGuideCoffeeLinks();
  refillMarquees();

  if (resplit) {
    queryAll("[data-split]").forEach((node) => {
      delete node.dataset.splitReady;
    });
    splitText();
  }
}

function initLanguage() {
  let savedLanguage;
  try { savedLanguage = localStorage.getItem("nubia-lang-v1"); } catch {}
  const pageLanguage = (root.lang || "fr").toLowerCase().startsWith("en") ? "en" : "fr";
  applyLanguage(savedLanguage === "en" || savedLanguage === "fr" ? savedLanguage : pageLanguage, false);
  queryAll("[data-lang-toggle]").forEach((button) => {
    button.addEventListener("click", () => {
      applyLanguage(state.lang === "fr" ? "en" : "fr", true);
      pulse(button);
    });
  });
}

const marqueeFillers = [];

function setupMarquee(track, pxPerSecond) {
  if (!track || track.dataset.marqueeReady) return;
  const strip = track.parentElement;
  const count = Number(track.dataset.marqueeCount);
  const originals = [...track.children].slice(0, count);
  if (!strip || !count || originals.length !== count) return;
  const isRitual = track.classList.contains("da-ritual-track");

  const makeCloneSet = () => originals.map((node) => {
    const clone = node.cloneNode(true);
    clone.dataset.marqueeClone = "1";
    clone.setAttribute("aria-hidden", "true");
    if (isRitual) clone.classList.add("is-clone");
    if (clone.matches("a, button")) clone.tabIndex = -1;
    clone.querySelectorAll("a, button, input, select, textarea, [tabindex]").forEach(el => { el.tabIndex = -1; });
    return clone;
  });

  const fill = () => {
    // Keep one canonical cycle; do not accidentally include the server fallback copies.
    [...track.children].forEach(node => { if (!originals.includes(node)) node.remove(); });
    track.style.removeProperty("--marquee-shift");
    track.style.removeProperty("animation-duration");
    if (getComputedStyle(track).animationName === "none") return;
    const firstSet = makeCloneSet();
    firstSet.forEach(node => track.appendChild(node));
    // Both edges share the animated transform. Their difference retains subpixel precision.
    const cycle = firstSet[0].getBoundingClientRect().left - originals[0].getBoundingClientRect().left;
    if (cycle <= 0) return;
    const cycles = Math.max(2, Math.ceil((strip.clientWidth + 2) / cycle) + 1);
    for (let i = 2; i < cycles; i++) makeCloneSet().forEach(node => track.appendChild(node));
    track.style.setProperty("--marquee-shift", `-${cycle}px`);
    track.style.setProperty("animation-duration", `${Math.max(8, cycle / pxPerSecond)}s`, "important");
  };

  fill();
  marqueeFillers.push(fill);
  track.dataset.marqueeReady = "1";
  if ("ResizeObserver" in window) {
    let width = strip.clientWidth;
    const observer = new ResizeObserver(() => {
      if (strip.clientWidth === width) return;
      width = strip.clientWidth;
      fill();
    });
    observer.observe(strip);
  }
}

function refillMarquees() { marqueeFillers.forEach(fn => fn()); }

function initMarquees() {
  queryAll(".announcement-track").forEach(track => setupMarquee(track, 24));
  queryAll(".da-ritual-track").forEach(track => setupMarquee(track, 25));
  if (document.fonts?.ready) document.fonts.ready.then(refillMarquees).catch(() => {});
}

function normalizeSearchText(value) {
  return String(value ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase().replace(/\b(?:filtre|filtres|filters)\b/g, "filter").replace(/\s+/g, " ").trim();
}

function initSearch() {
  const overlay = $("#search-overlay");
  const input = $("[data-search-input]");
  const results = $("[data-search-results]");
  if (!overlay || !input || !results) return;

  const escapeSearchHtml = (value) => String(value ?? "").replace(/[&<>"']/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;"
  }[character]));
  const render = (query = "") => {
    const q = normalizeSearchText(query);
    // Match words across product fields; quoted expressions stay together.
    const terms = Array.from(q.matchAll(/"([^"]+)"|(\S+)/g), (match) => match[1] || match[2]);
    const matches = state.products.filter((product) => {
      const blob = normalizeSearchText([product.name, product.label, product.description, (Array.isArray(product.notes) ? product.notes : []).join(" "), (Array.isArray(product.methods) ? product.methods : []).join(" ")].join(" "));
      return terms.every((term) => blob.includes(term));
    });
    results.innerHTML = matches.length ? matches.map((product) => `<a class="search-result" href="${escapeSearchHtml(pathFor(`/products/${encodeURIComponent(product.slug)}`))}" style="--accent:${escapeSearchHtml(product.accent || "#c08552")};--soft:${escapeSearchHtml(product.soft || "rgba(192, 133, 82, 0.18)")};">
      <img src="${escapeSearchHtml(product.tile || product.image || "")}" alt="${escapeSearchHtml(product.name)}" />
      <div><strong>${escapeSearchHtml(product.name)}</strong><small><span>${escapeSearchHtml(translateText(product.label || ""))}</span> / ${(Array.isArray(product.notes) ? product.notes : []).slice(0, 3).map(note => `<span>${escapeSearchHtml(translateText(note))}</span>`).join(", ")}</small></div>
      <span>${escapeSearchHtml(product.price)}</span>
    </a>`).join("") : `<div class="search-result"><div></div><strong>${translateText("Aucun profil trouve.")}</strong><span>${translateText("Essaie espresso ou latte")}</span></div>`;
    applyAutoTranslations(state.lang);
  };

  const open = async (event) => {
    event?.preventDefault();
    await loadProducts();
    render(input.value);
    overlay.classList.add("is-open");
    overlay.setAttribute("aria-hidden", "false");
    setTimeout(() => input.focus(), 60);
  };
  const close = () => {
    overlay.classList.remove("is-open");
    overlay.setAttribute("aria-hidden", "true");
  };

  queryAll("[data-search-toggle]").forEach((button) => button.addEventListener("click", open));
  queryAll("[data-search-close]").forEach((button) => button.addEventListener("click", close));
  input.addEventListener("input", () => render(input.value));
  overlay.addEventListener("click", (event) => { if (event.target === overlay) close(); });
  window.addEventListener("keydown", (event) => {
    if (event.key === "Escape") close();
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "k") {
      event.preventDefault();
      open();
    }
  });
}

function initBulk() {
  const modal = $("#bulk-modal");
  if (!modal) return;
  const title = $("[data-bulk-title]", modal);
  const sub = $("[data-bulk-sub]", modal);
  const results = $("[data-bulk-results]", modal);
  const note = $("[data-bulk-note]", modal);
  const custom = $("[data-bulk-custom]", modal);
  if (!results) return;
  if (note) {
    note.setAttribute("role", "status");
    note.setAttribute("aria-live", "polite");
  }
  let prices = {};
  let opener = null;

  const showError = (message) => {
    results.innerHTML = "";
    if (note) note.textContent = message;
    else results.textContent = message;
    custom?.setAttribute("aria-invalid", "true");
    custom?.setCustomValidity(message);
  };

  const render = (nextKg) => {
    const kg = Number(nextKg);
    if (!Number.isFinite(kg) || kg <= 0) {
      showError(state.lang === "en" ? "Enter a quantity greater than 0 kg." : "Entre une quantité supérieure à 0 kg.");
      return;
    }
    const entries = Object.entries(prices)
      .map(([size, price]) => [Number(size), Number(price)])
      .filter(([size, price]) => Number.isFinite(size) && size > 0 && Number.isFinite(price) && price >= 0)
      .sort((a, b) => a[0] - b[0]);
    if (!entries.length) {
      showError(state.lang === "en" ? "Prices are unavailable for this product." : "Les prix sont indisponibles pour ce produit.");
      return;
    }
    const rows = entries.map(([grams, bagPrice]) => {
      const bags = Math.ceil(kg * 1000 / grams);
      const total = bags * bagPrice;
      return { grams, bagPrice, bags, total, retail: total * 1.35 };
    });
    if (rows.some((row) => !Number.isSafeInteger(row.bags) || !Number.isSafeInteger(Math.round(row.total * 100)) || !Number.isSafeInteger(Math.round(row.retail * 100)))) {
      showError(state.lang === "en" ? "The quantity is too large." : "La quantité est trop élevée.");
      return;
    }
    custom?.removeAttribute("aria-invalid");
    custom?.setCustomValidity("");
    const lowest = Math.min(...entries.map(([size, price]) => price / (size / 1000)));
    results.innerHTML = `<div class="bulk-row"><strong>${translateText("Format")}</strong><span>${translateText("Sacs")}</span><span>${translateText("Cost")}</span><span>+35%</span></div>${rows.map(({ grams, bagPrice, bags, total, retail }) => {
      const best = Math.abs((bagPrice / (grams / 1000)) - lowest) < 0.01;
      const label = grams === 1000 ? "1 kg" : grams === 2270 ? "2.27 kg" : `${grams} g`;
      const bestLabel = state.lang === "en" ? "best price/kg" : "meilleur prix/kg";
      return `<div class="bulk-row ${best ? "best" : ""}"><strong>${label}${best ? ` / ${bestLabel}` : ""}</strong><span>${bags}</span><span>${money(total)}</span><span>${money(retail)}</span></div>`;
    }).join("")}`;
    if (note) note.textContent = state.lang === "en"
      ? `Local calculation to cover ${kg} kg. Bags are rounded up.`
      : `Calcul local pour couvrir ${kg} kg. Les sacs sont arrondis vers le haut.`;
    applyAutoTranslations(state.lang);
  };

  const open = (button) => {
    opener = button;
    try { prices = JSON.parse(button.dataset.bulkPrices || "{}"); } catch { prices = {}; }
    if (!prices || typeof prices !== "object" || Array.isArray(prices)) prices = {};
    if (title) title.textContent = button.dataset.bulkName || "Nubia";
    if (sub) sub.textContent = `${button.dataset.bulkSub || "Profil Nubia"} / Bulk order calculator`;
    const tonePaint = {
      red: "#ef4b1f", violet: "#8d4bb2", sage: "#7e8f55",
      copper: "#bd6a31", gold: "#c98b2f", blue: "#126dd8"
    };
    const paint = tonePaint[button.dataset.bulkTone] || button.dataset.bulkAccent || "#c08552";
    modal.style.setProperty("--pdp-paint", paint);
    modal.style.setProperty("--pdp-button", `color-mix(in srgb, ${paint} 74%, #3f1f11)`);
    if (custom) custom.value = "";
    queryAll("[data-bulk-qty]", modal).forEach((tab, index) => tab.classList.toggle("active", index === 0));
    render(10);
    modal.classList.add("is-open");
    modal.setAttribute("aria-hidden", "false");
    (custom || $("[data-bulk-close]", modal))?.focus();
  };
  const close = () => {
    if (!modal.classList.contains("is-open")) return;
    modal.classList.remove("is-open");
    modal.setAttribute("aria-hidden", "true");
    opener?.focus();
  };

  queryAll("[data-bulk-open]").forEach((button) => button.addEventListener("click", () => open(button)));
  queryAll("[data-bulk-close]").forEach((button) => button.addEventListener("click", close));
  queryAll("[data-bulk-qty]", modal).forEach((button) => button.addEventListener("click", () => {
    queryAll("[data-bulk-qty]", modal).forEach((tab) => tab.classList.toggle("active", tab === button));
    if (custom) custom.value = "";
    render(Number(button.dataset.bulkQty));
  }));
  custom?.addEventListener("input", () => {
    queryAll("[data-bulk-qty]", modal).forEach((tab) => tab.classList.remove("active"));
    render(custom.value.trim() ? Number(custom.value) : NaN);
  });
  modal.addEventListener("click", (event) => { if (event.target === modal) close(); });
  modal.addEventListener("keydown", (event) => {
    if (event.key !== "Tab" || !modal.classList.contains("is-open")) return;
    const focusable = queryAll("a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])", modal)
      .filter((node) => node.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (!first) return;
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  window.addEventListener("keydown", (event) => { if (event.key === "Escape") close(); });
}

async function loadAnime() {
  // Current storefront pages use the native animation path below.
  if (prefersReduced || offlineMode || $(".da-site")) return null;
  const allowCdn = !/^(localhost|127\.0\.0\.1)$/i.test(location.hostname) || new URLSearchParams(location.search).has("animecdn");
  if (!allowCdn) return null;
  try {
    return await import(window.NubiaAnimeUrl);
  } catch {
    try {
      return null;
    } catch {
      return null;
    }
  }
}

function waapi(targets, keyframes, options = {}, stagger = 0) {
  const list = typeof targets === "string" ? queryAll(targets) : (targets instanceof Element ? [targets] : [...targets].filter(Boolean));
  return list.map((node, index) => node.animate(keyframes, {
    duration: options.duration || 720,
    delay: (options.delay || 0) + index * stagger,
    easing: options.easing || "cubic-bezier(.16,1,.3,1)",
    fill: "both"
  }));
}

function pulse(target) {
  if (!target || prefersReduced) return;
  if (state.anime?.animate && state.anime?.spring) {
    try {
      state.anime.animate(target, { scale: [1, .965, 1], ease: state.anime.spring({ bounce: .25, duration: 360 }) });
      return;
    } catch {}
  }
  waapi(target, [{ transform: "scale(1)" }, { transform: "scale(.965)" }, { transform: "scale(1)" }], { duration: 280, easing: "cubic-bezier(.18,1.2,.32,1)" });
}

function splitText() {
  queryAll("[data-split]").forEach((node) => {
    if (node.dataset.splitReady) return;
    node.dataset.splitReady = "true";
    if (state.anime?.splitText) {
      try {
        const split = state.anime.splitText(node, { words: { wrap: "span", class: "split-word" } });
        if (split?.words?.length) return;
      } catch {}
    }
    const fragment = document.createDocumentFragment();
    node.textContent.trim().split(/\s+/).forEach((word, index) => {
      if (index) fragment.appendChild(document.createTextNode(" "));
      const span = document.createElement("span");
      span.className = "split-word";
      span.textContent = word;
      fragment.appendChild(span);
    });
    node.replaceChildren(fragment);
  });
}

function animateIntro() {
  if (prefersReduced) return;
  if ($(".da-site")) {
    const springEase = "cubic-bezier(.16,1,.3,1)";
    waapi(queryAll(".da-scene-copy, .da-hero-profile, .da-product-card, .da-shop-tools, .da-buy-box, .product-gallery, .admin-panel, .admin-kpi"), [
      { opacity: 0, transform: "translateY(14px)" },
      { opacity: 1, transform: "translateY(0)" }
    ], { duration: 420, delay: 40, easing: springEase }, 38);
    return;
  }
  const words = queryAll("[data-split] .split-word");
  const springEase = "cubic-bezier(.18,1.18,.32,1)";
  let animeGuideMotion = false;

  if (state.anime?.animate && state.anime?.stagger) {
    try {
      state.anime.animate(words, {
        opacity: [0, 1],
        translateY: [36, 0],
        rotateX: [16, 0],
        filter: ["blur(10px)", "blur(0px)"],
        delay: state.anime.stagger(38, { start: 100 }),
        duration: 900,
        ease: state.anime.spring ? state.anime.spring({ bounce: .18, duration: 650 }) : "out(3)"
      });
      state.anime.animate(".trace", {
        strokeDashoffset: [680, 0],
        delay: state.anime.stagger(130, { start: 260 }),
        duration: 1250,
        ease: state.anime.spring ? state.anime.spring({ bounce: .28, duration: 720 }) : "out(3)"
      });
      state.anime.animate(".guide-orbit path", {
        strokeDashoffset: [700, 0],
        delay: state.anime.stagger(160, { start: 340 }),
        duration: 1300,
        ease: state.anime.spring ? state.anime.spring({ bounce: .2, duration: 760 }) : "out(3)"
      });
      state.anime.animate(".card-accent", {
        scaleX: [0, 1],
        transformOrigin: "0 50%",
        delay: state.anime.stagger(52, { start: 220 }),
        duration: 760,
        ease: state.anime.spring ? state.anime.spring({ bounce: .16, duration: 520 }) : "out(3)"
      });
      state.anime.animate(".bar-fill", {
        scaleX: [0, 1],
        transformOrigin: "0 50%",
        delay: state.anime.stagger(24, { start: 420 }),
        duration: 620,
        ease: state.anime.spring ? state.anime.spring({ bounce: .12, duration: 480 }) : "out(3)"
      });
      animeGuideMotion = true;
    } catch {
      waapi(words, [
        { opacity: 0, transform: "translateY(36px) rotateX(16deg)", filter: "blur(10px)" },
        { opacity: 1, transform: "translateY(0) rotateX(0deg)", filter: "blur(0)" }
      ], { duration: 900, easing: springEase }, 38);
    }
  } else {
    waapi(words, [
      { opacity: 0, transform: "translateY(36px) rotateX(16deg)", filter: "blur(10px)" },
      { opacity: 1, transform: "translateY(0) rotateX(0deg)", filter: "blur(0)" }
    ], { duration: 900, delay: 100, easing: springEase }, 38);
    waapi(".trace", [
      { strokeDashoffset: 680 },
      { strokeDashoffset: 0 }
    ], { duration: 1250, delay: 260, easing: springEase }, 130);
    waapi(".guide-orbit path", [
      { strokeDashoffset: 700 },
      { strokeDashoffset: 0 }
    ], { duration: 1300, delay: 340, easing: springEase }, 160);
  }

  if (!animeGuideMotion) {
    waapi(".card-accent", [
      { transform: "scaleX(0)" },
      { transform: "scaleX(1)" }
    ], { duration: 760, delay: 180, easing: springEase }, 52);
    waapi(".bar-fill", [
      { transform: "scaleX(0)" },
      { transform: "scaleX(1)" }
    ], { duration: 620, delay: 420, easing: springEase }, 24);
  }

  waapi(queryAll(".hero-copy > .eyebrow, .hero-copy > p, .home-cinema-copy > p, .storefront-copy > p, .commerce-copy > p, .home-v5-copy > p, .guide-studio-copy > p, .guide-practical-copy > p, .brand-hero-copy > .eyebrow, .brand-hero-copy > p, .hero-controls, .hero-actions, .hero-console, .cinema-stage, .storefront-visual, .commerce-interface, .home-v5-media, .ritual-dock, .guide-studio-stage, .guide-practical-media, .product-card, .product-gallery, .product-buy-box, .admin-panel, .admin-kpi"), [
    { opacity: 0, transform: "translateY(18px)" },
    { opacity: 1, transform: "translateY(0)" }
  ], { duration: 720, delay: 160, easing: springEase }, 62);
}

function initGuideReveals() {
  if (prefersReduced || !("IntersectionObserver" in window)) return;
  const items = queryAll(".section .product-card, .section [data-card], .pdp-details [data-card], .pdp-story-v5 article, .education-grid article, .origin-block [data-card], .visual-story-card, .mission-band, .origin-rhythm, .coffee-chooser, .product-path, .path-card, .origin-service, .morning-panel, .club-signup, .quick-buy-bar, .taste-lab, .taste-matrix a, .shop-floor, .shop-tile, .origin-proof, .bundle-club, .answer-card, .compare-guide, .brew-cards article, .home-v5-products, .v5-product-card, .origin-v5, .trust-v5 article, .club-v5, .catalogue-v5-guide, .home-shop-strip, .ritual-window, .strip-product, .decision-steps article, .brew-map, .origin-explainer, .guide-scroll-copy article, .guide-method-wall, .guide-path article, .checkout-grid [data-card], .catalogue-toolbox");
  if (!items.length) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add("is-visible");
      entry.target.animate([
        { opacity: 0, transform: "translateY(20px)", filter: "blur(7px)" },
        { opacity: 1, transform: "translateY(0)", filter: "blur(0)" }
      ], {
        duration: 620,
        delay: Number.parseInt(entry.target.style.getPropertyValue("--reveal-delay") || "0", 10),
        easing: "cubic-bezier(.16,1,.3,1)",
        fill: "both"
      });
      observer.unobserve(entry.target);
    });
  }, { threshold: .16, rootMargin: "0px 0px -8% 0px" });

  items.forEach((item, index) => {
    item.classList.add("reveal-item");
    item.style.setProperty("--reveal-delay", `${Math.min(index % 4, 3) * 70}ms`);
    observer.observe(item);
  });
}

function initScroll() {
  const update = () => {
    const max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    const progress = clamp(scrollY / max, 0, 1);
    root.style.setProperty("--scroll", progress.toFixed(4));
  };
  update();
  addEventListener("scroll", update, { passive: true });
  addEventListener("resize", update, { passive: true });
}

function initPointer() {
  addEventListener("pointermove", (event) => {
    root.style.setProperty("--mx", `${event.clientX}px`);
    root.style.setProperty("--my", `${event.clientY}px`);
    state.pointer.x = event.clientX;
    state.pointer.y = event.clientY;
    const card = event.target.closest("[data-card], .product-card, .admin-panel, .admin-kpi, .hero-console");
    if (!card) return;
    const rect = card.getBoundingClientRect();
    card.style.setProperty("--spot-x", `${(((event.clientX - rect.left) / rect.width) * 100).toFixed(1)}%`);
    card.style.setProperty("--spot-y", `${(((event.clientY - rect.top) / rect.height) * 100).toFixed(1)}%`);
  }, { passive: true });
}

function initCanvas() {
  const canvas = $("#ambient-canvas");
  if (!canvas || prefersReduced) return;
  const ctx = canvas.getContext("2d", { alpha: true });
  if (!ctx) return;
  const colors = ["#9c6418", "#cfb298", "#527a36", "#7442ad", "#b93830"];
  let width = 0;
  let height = 0;
  let dpr = 1;

  const resize = () => {
    dpr = Math.min(devicePixelRatio || 1, 1.7);
    width = innerWidth;
    height = innerHeight;
    canvas.width = Math.round(width * dpr);
    canvas.height = Math.round(height * dpr);
    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
    const count = clamp(Math.round(width * height / 56000), 28, 70);
    state.particles = Array.from({ length: count }, (_, index) => ({
      x: Math.random() * width,
      y: Math.random() * height,
      vx: (Math.random() - .5) * .18,
      vy: -.08 - Math.random() * .22,
      r: .8 + Math.random() * 2.3,
      color: colors[index % colors.length],
      phase: Math.random() * Math.PI * 2
    }));
  };

  const draw = (time) => {
    ctx.clearRect(0, 0, width, height);
    ctx.globalCompositeOperation = "lighter";
    state.particles.forEach((dot, index) => {
      dot.x += dot.vx + Math.sin(time * .001 + dot.phase) * .06;
      dot.y += dot.vy;
      if (dot.y < -20) dot.y = height + 20;
      if (dot.x < -20) dot.x = width + 20;
      if (dot.x > width + 20) dot.x = -20;
      const pulseValue = .65 + Math.sin(time * .002 + index) * .35;
      ctx.beginPath();
      ctx.globalAlpha = .1 + pulseValue * .08;
      ctx.fillStyle = dot.color;
      ctx.arc(dot.x, dot.y, dot.r + pulseValue, 0, Math.PI * 2);
      ctx.fill();
    });
    ctx.globalAlpha = 1;
    ctx.globalCompositeOperation = "source-over";
    requestAnimationFrame(draw);
  };

  resize();
  addEventListener("resize", resize);
  requestAnimationFrame(draw);
}

function initProfileControls() {
  const wrappers = queryAll("[data-profile-controls]");
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const scope = wrapper.closest("[data-profile-root]") || document;
    const stageImage = $("[data-stage-image]", scope);
    const stageName = $("[data-stage-name]", scope);
    const stageLabel = $("[data-stage-label]", scope);
    const stagePrice = $("[data-stage-price]", scope);
    const stageLink = $("[data-stage-link]", scope);
    const hero = scope instanceof Element && scope.matches("[data-hero]") ? scope : $("[data-hero]", scope);

    wrapper.addEventListener("click", (event) => {
      const button = event.target.closest("[data-profile]");
      if (!button) return;
      queryAll("[data-profile]", wrapper).forEach((node) => node.classList.toggle("active", node === button));
      if (stageImage) {
        stageImage.src = button.dataset.image;
        stageImage.alt = `${button.dataset.name} Nubia`;
        pulse(stageImage);
      }
      if (stageName) stageName.textContent = button.dataset.name || "";
      if (stageLabel) stageLabel.textContent = button.dataset.label || "";
      if (stagePrice) stagePrice.textContent = button.dataset.price || "";
      if (stageLink && button.dataset.url) stageLink.href = button.dataset.url;
      if (hero && button.dataset.accent) hero.style.setProperty("--accent", button.dataset.accent);
      if (hero && button.dataset.soft) hero.style.setProperty("--soft", button.dataset.soft);
      if (button.dataset.ritualTarget) {
        const productCard = document.querySelector(`[data-product-card="${button.dataset.ritualTarget}"]`);
        if (productCard) {
          productCard.scrollIntoView({ behavior: prefersReduced ? "auto" : "smooth", block: "center" });
          pulse(productCard);
        }
      }
      track("product_select", { product: button.dataset.profile, source: "hero_control" });
    });
  });
}

function runInitializer(initializer) {
  try {
    initializer();
  } catch (error) {
    console.warn(`[Nubia] ${initializer.name} could not initialize.`, error);
  }
}

async function boot() {
  await loadProducts().catch((error) => console.warn("[Nubia] Product catalogue could not initialize.", error));
  // Bind shopping controls before any optional presentation effects.
  runInitializer(initSearch);
  runInitializer(initBulk);

  root.classList.add("motion-ready");
  // Optional animations must never delay navigation, search or product controls.
  root.dataset.animeEngine = "local-spring-fallback";
  loadAnime().then((anime) => {
    state.anime = anime;
    root.dataset.animeEngine = anime ? "animejs" : "local-spring-fallback";
  }).catch((error) => console.warn("[Nubia] Optional animation engine could not load.", error));

  [initCompareProfiles, initLanguage, splitText, initScroll, initGuideReveals,
    initPointer, initCanvas, initMarquees, initProfileControls, animateIntro]
    .forEach(runInitializer);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}

// Phase 15: transparent preference matching, no personal data collected or stored.
function nubiaCoffeeScores(picks) {
  const profiles = [
    {slug:'aurora',level:0,notes:0,methods:[0,1,2]},
    {slug:'cameroun',level:1,notes:1,methods:[1,2]},
    {slug:'atlas',level:1,notes:2,methods:[0,1,2]},
    {slug:'onyx',level:2,notes:2,methods:[0,1]},
    {slug:'titan',level:3,notes:1,methods:[0,3]},
    {slug:'vulcan',level:3,notes:3,methods:[0,1,3]}
  ];
  return profiles.map(p=>({...p,score:12-4*Math.abs(p.level-picks[1])+(p.notes===picks[2]?3:0)+(p.methods.includes(picks[0])?2:0)})).sort((a,b)=>b.score-a.score);
}
function initNubiaCoffeeFinder() {
  const panel=document.querySelector('[data-coffee-quiz]');
  if(!panel || panel.dataset.ready) return;
  panel.dataset.ready='true';
  const body=panel.querySelector('[data-quiz-body]');
  const meter=[...panel.querySelectorAll('.nb-quiz-meter span')];
  const cup='<svg class="nb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h12v7a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5ZM16 9h2a3 3 0 0 1 0 6h-2M7 2v3m4-3v3M2 22h18"/></svg>';
  const levels=i=>'<svg class="nb-icon" viewBox="0 0 24 24" aria-hidden="true">'+[0,1,2,3].map(n=>`<rect x="${2+n*6}" y="${16-n*4}" width="4" height="${6+n*4}" rx="1" fill="currentColor" opacity="${n<=i?1:.22}"/>`).join('')+'</svg>';
  const leaf='<svg class="nb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M20 3C8 2 2 8 4 15s14 7 16-12ZM5 19 17 7"/></svg>';
  const copy={
    fr:{questions:[['Comment préparez-vous votre café ?',['Espresso','Avec du lait','Filtre / pour-over','Presse française / moka']],['Dans votre tasse, vous aimez…',['La douceur','L’équilibre','Le corps & la texture','Un caractère intense']],['Quelles notes vous attirent ?',['Fruits & miel','Noix & cacao','Caramel & chocolat','Épices & chocolat noir']]],step:'Question',of:'sur',back:'← Retour',restart:'Recommencer',change:'Modifier mes réponses',result:'Votre café à découvrir',link:'Découvrir ce café →',unavailable:'Voir le profil · momentanément épuisé',note:'Une piste selon vos goûts. La mouture et la préparation font aussi évoluer la tasse.',empty:'Explorez les profils dans notre guide.',reason:'Vous recherchez',bridge:'Voici un point de départ pour votre prochaine tasse.',guide:'Voir le guide'},
    en:{questions:[['How do you brew your coffee?',['Espresso','With milk','Filter / pour-over','French press / moka']],['In your cup, you enjoy…',['Gentleness','Balance','Body & texture','Bold character']],['Which flavours appeal to you?',['Fruit & honey','Nuts & cacao','Caramel & chocolate','Spice & dark chocolate']]],step:'Question',of:'of',back:'← Back',restart:'Start again',change:'Change my answers',result:'Your coffee to discover',link:'Discover this coffee →',unavailable:'View profile · currently sold out',note:'A starting point based on your tastes. Grind and brewing also shape your cup.',empty:'Explore the profiles in our coffee guide.',reason:'You enjoy',bridge:'A starting point for your next cup.',guide:'Read the guide'}
  };
  const descriptions={
    aurora:{fr:'Aurore-237 apporte de la douceur, avec des notes de chocolat au lait, de fruits rouges et de miel.',en:'Aurore-237 brings softness with notes of milk chocolate, red fruits and honey.'},
    cameroun:{fr:'Continent offre une tasse ronde, aux notes de noix torréfiées et de cacao. Un profil qui se prête aussi aux boissons lactées.',en:'Continent offers a round cup with roasted nut and cacao notes. A profile that also works well with milk.'},
    atlas:{fr:'SAWA réunit caramel, chocolat noir et amandes torréfiées dans un profil équilibré.',en:'SAWA brings caramel, dark chocolate and roasted almonds together in a balanced profile.'},
    onyx:{fr:'Oku mise sur le corps et une texture crémeuse, avec du chocolat noir, des noix et une touche de cassis.',en:'Oku offers body and a creamy texture, with dark chocolate, nuts and a touch of black currant.'},
    titan:{fr:'Volcan donne une tasse dense, portée par le chocolat noir, les éclats de cacao et les noix torréfiées.',en:'Volcan delivers a dense cup with dark chocolate, cacao nibs and roasted nuts.'},
    vulcan:{fr:'Moungo exprime un caractère intense, avec du cacao, du chocolat noir et des notes épicées.',en:'Moungo expresses bold character with cacao, dark chocolate and spice notes.'}
  };
  let step=0,picks=[],finished=false;
  const lang=()=>document.body.dataset.lang==='en'?'en':'fr';
  function element(tag,cls,text){const n=document.createElement(tag);if(cls)n.className=cls;if(text)n.textContent=text;return n;}
  function button(text,cls,callback){const b=element('button',cls,text);b.type='button';b.addEventListener('click',callback);return b;}
  function render(focus=false){
    const l=lang(),c=copy[l];body.replaceChildren();
    const content=element('div','nb-quiz-body-enter');body.append(content);
    meter.forEach((m,i)=>m.classList.toggle('is-done',finished||i<=step));
    const label=element('span','nb-quiz-label',finished?c.result:`${c.step} ${step+1} ${c.of} 3`);content.append(label);
    let heading;
    if(!finished){
      heading=element('h3','',c.questions[step][0]);heading.id='nb-current-question';heading.tabIndex=-1;content.append(heading);
      const answers=element('div','nb-quiz-answers');answers.setAttribute('role','group');answers.setAttribute('aria-labelledby',heading.id);
      c.questions[step][1].forEach((text,i)=>{
        const b=button('','nb-quiz-answer',()=>{picks[step]=i;if(step<2)step++;else finished=true;render(true);});
        b.setAttribute('aria-pressed',picks[step]===i?'true':'false');b.innerHTML=step===0?cup:step===1?levels(i):leaf;b.append(element('span','',text));answers.append(b);
      });content.append(answers);
      const controls=element('div','nb-quiz-controls');if(step>0)controls.append(button(c.back,'nb-quiz-back',()=>{step--;render(true);}));content.append(controls);
    }else{
      const products=window.__NUBIA_BOOTSTRAP__?.products||[];
      const ranking=nubiaCoffeeScores(picks);
      const chosen=ranking.find(p=>products.some(x=>x.slug===p.slug));
      const product=chosen&&products.find(p=>p.slug===chosen.slug);
      const result=element('div','nb-quiz-result');
      if(product){
        const img=element('img');img.src=product.image;img.alt=product.name;img.width=160;img.height=160;result.append(img);
        const description=element('div');heading=element('h3','',product.name);heading.tabIndex=-1;description.append(heading,element('p','',descriptions[chosen.slug][l]));
        const link=element('a','nb-quiz-product-link',product.available?c.link:c.unavailable);link.href=`/products/${encodeURIComponent(product.slug)}`;description.append(link);result.append(description);
      }else{heading=element('h3','',c.empty);heading.tabIndex=-1;const link=element('a','nb-quiz-product-link',c.guide);link.href='/pages/apprendre';result.append(heading,link);}
      content.append(result);
      const note=element('small','nb-quiz-note',c.note);content.append(note);
      const controls=element('div','nb-quiz-controls');controls.append(button(c.change,'nb-quiz-back',()=>{finished=false;step=2;render(true);}),button(c.restart,'nb-quiz-back',()=>{finished=false;step=0;picks=[];render(true);}));content.append(controls);
    }
    if(focus)heading.focus({preventScroll:true});
  }
  new MutationObserver(()=>render()).observe(document.body,{attributes:true,attributeFilter:['data-lang']});
  render();
}
runInitializer(initNubiaCoffeeFinder);


// Phase16: navigation visible on upward scroll, with keyboard-safe mobile menu.
(function initNubiaNavigation(){
  document.documentElement.classList.add('js');
  const wrap=document.getElementById('shopify-section-header');
  const header=wrap?.querySelector('.site-nav');
  if(!header)return;
  const toggle=header.querySelector('.nb-menu-toggle');
  const nav=header.querySelector('nav');
  const quote=wrap.querySelector('.nb-floating-quote');
  if(quote)document.body.appendChild(quote);
  let anchor=window.scrollY, pending=false;
  const setMenu=(open)=>{header.classList.toggle('nb-menu-open',open);toggle?.setAttribute('aria-expanded',String(open));wrap.classList.remove('nb-nav-hidden');};
  const measure=()=>{wrap.style.setProperty('--nb-ann-height',`${wrap.querySelector('.announcement')?.offsetHeight||0}px`);if(innerWidth>1100)setMenu(false);};
  const update=()=>{
    const y=Math.max(0,window.scrollY),delta=y-anchor;
    if(y<wrap.offsetHeight||header.classList.contains('nb-menu-open'))wrap.classList.remove('nb-nav-hidden');
    else if(Math.abs(delta)>7){wrap.classList.toggle('nb-nav-hidden',delta>0);anchor=y;}
    if(y<wrap.offsetHeight)anchor=y;
    pending=false;
  };
  toggle?.addEventListener('click',()=>setMenu(toggle.getAttribute('aria-expanded')!=='true'));
  nav?.addEventListener('click',e=>{if(e.target.closest('a'))setMenu(false);});
  header.addEventListener('focusin',()=>wrap.classList.remove('nb-nav-hidden'));
  header.addEventListener('keydown',e=>{if(e.key==='Escape'&&header.classList.contains('nb-menu-open')){setMenu(false);toggle.focus();}});
  addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(update);}},{passive:true});
  addEventListener('resize',measure,{passive:true});
  measure();update();
})();


// Shopify Customer Privacy API: store-native consent, no private cookie handling.
(function initNubiaPrivacy(){
 const panel=document.getElementById('nb-privacy-panel');
 const opener=document.querySelector('[data-nb-privacy-open]');
 if(!panel||!opener)return;
 const status=panel.querySelector('[data-nb-privacy-status]');
 const form=panel.querySelector('form');
 const fields=[...form.querySelectorAll('input[name]')];
 let api,requestOpen=false,lastFocus;
 const message=(fr,en)=>{status.textContent=document.body.dataset.lang==='en'?en:fr;};
 const populate=()=>{const consent=api.currentVisitorConsent();fields.forEach(f=>f.checked=consent[f.name]==='yes');};
 const show=()=>{lastFocus=document.activeElement;status.textContent='';if(api)populate();if(!panel.open)panel.showModal();};
 const close=()=>{panel.close();lastFocus?.focus();};
 opener.addEventListener('click',()=>{requestOpen=true;show();if(!api)message('Chargement des préférences…','Loading preferences…');});
 panel.querySelector('[data-nb-privacy-close]').addEventListener('click',close);
 const save=(all)=>{
   if(!api){message('Les préférences sont temporairement indisponibles. Réessayez dans un instant.','Preferences are temporarily unavailable. Please try again shortly.');return;}
   const values=Object.fromEntries(fields.map(f=>[f.name,typeof all==='boolean'?all:f.checked]));
   const buttons=[...panel.querySelectorAll('[data-nb-consent]')];buttons.forEach(b=>b.disabled=true);
   api.setTrackingConsent(values,(result)=>{
     buttons.forEach(b=>b.disabled=false);
     if(result?.error){message('Vos choix n’ont pas pu être enregistrés. Veuillez réessayer.','Your choices could not be saved. Please try again.');return;}
     const saved=api.currentVisitorConsent();
     if(fields.some(f=>saved[f.name]!== (values[f.name]?'yes':'no'))){message('Vos choix n’ont pas pu être confirmés. Veuillez réessayer.','Your choices could not be confirmed. Please try again.');return;}
     populate();message('Vos préférences sont enregistrées. Vous pouvez les modifier ici à tout moment.','Your preferences are saved. You can change them here at any time.');
   });
 };
 form.addEventListener('submit',e=>{e.preventDefault();save();});
 panel.querySelector('[data-nb-consent="reject"]').addEventListener('click',()=>save(false));
 panel.querySelector('[data-nb-consent="accept"]').addEventListener('click',()=>save(true));
 const ready=(error)=>{
   if(error||!window.Shopify?.customerPrivacy){if(requestOpen)message('Les préférences sont temporairement indisponibles. Réessayez plus tard.','Preferences are temporarily unavailable. Please try again later.');return;}
   api=window.Shopify.customerPrivacy;
   if(requestOpen){populate();status.textContent='';}
   // Follow the shop's regional requirement; do not silently change global privacy settings.
   if(api.shouldShowBanner()&&!document.querySelector('#shopify-pc__banner')&&!panel.open){populate();panel.show();}
 };
 if(window.Shopify?.customerPrivacy)ready();
 else if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],ready);
})();

// Phase17: native footer disclosures and an on-demand map, without preloading Google.
(() => {
  const mq=window.matchMedia('(max-width:760px)');
  const groups=document.querySelectorAll('.nb-footer-group');
  const arrange=()=>groups.forEach(group=>{group.open=!mq.matches;group.querySelector('summary').tabIndex=mq.matches?0:-1;});
  arrange();mq.addEventListener('change',arrange);
  document.querySelectorAll('[data-nb-map-load]').forEach(button=>button.addEventListener('click',()=>{
    const frame=document.createElement('iframe');
    frame.title='Maison Nubia — 7998 Rue Jarry E, Anjou';
    frame.src='https://maps.google.com/maps?q=7998%20Rue%20Jarry%20E%2C%20Anjou%2C%20QC%20H1J%201H5&z=15&output=embed';
    frame.loading='lazy';frame.referrerPolicy='no-referrer-when-downgrade';
    button.parentElement.replaceChildren(frame);frame.focus();
  }));
})();
